import React from "react";
import { useParams } from "react-router-dom";
import {
  PublicReportPageSkeleton,
  PublicReportRouteSkeletonContainer,
} from "../components/collectionContent/CollectionPageSkeletons";

/** Lightweight fallback while the public report page chunk loads. */
export function PublicSponsorLinkRouteSkeleton() {
  const { brandId } = useParams<{ brandId?: string }>();
  const isBrandReport = Boolean(brandId);

  return (
    <PublicReportRouteSkeletonContainer>
      <PublicReportPageSkeleton
        showBrandSections={isBrandReport}
        showLivestreams
        isBrandReport={isBrandReport}
      />
    </PublicReportRouteSkeletonContainer>
  );
}

export default PublicSponsorLinkRouteSkeleton;
